import * as React from 'react';

import { Dispatch } from 'redux';
import { connect } from 'react-redux';

import { TwoColumnContainer } from '../../components/two_column_container/two_column_container';
import { FiltersContainer } from '../../components/filters_container/filters_container';

import { NewBuildingCaption } from '../../containers/new_building_caption/new_building_caption';
import { Filters } from '../../containers/search_block/filters';
import { NewSeoUrlsWrapper } from '../../containers/new_seo_urls/new_seo_urls';
import { PopularList } from '../../containers/popular_list/popular_list';
import { JKPopularList } from '../../containers/popular_jk/popular_jk';
import { SeoContainer } from '../../components/seo_container/seo_container';
import { Promo } from '../../containers/promo/promo';
import { CommercialPromo } from '../../containers/commercial_promo/commercial_promo';
import { VerticalPromo } from '../../containers/vertical_promo/vertical_promo';
import { SeoBlockContainer } from '../../containers/seo_block/seo_block';
import { Services } from '../../containers/services/services';
import { SaleServices } from '../../containers/sale_services/sale_services';
import { MagazineContainer } from '../../containers/magazine/magazine';
import { VacanciesContainer } from '../../containers/vacancies/vacancies';
import { NewBuildingsServices } from '../../containers/new_buildings_service/new_buildings_services';
import { Specialists } from '../../containers/specialists/specialists';

import { IMainPage } from '../../models/mainpage';
import { ITopThreeItem } from '../../models/top_three';
import { ITopJK } from '../../models/top_three';

interface IProps {
  dispatch?: Dispatch<any>;
  isFetching: boolean;
  top3?: ITopThreeItem[];
  popularJks?: ITopJK[];
  section: string;
}

interface IHomeState {
  mainpage: IMainPage;
}

interface IHomeProps {
  section: string;
}

class HomeComponent extends React.Component<IProps> {
  public renderPromo() {
    switch (this.props.section) {
    case 'index':
      return (<Promo/>);
    case 'daily-rent':
    case 'sale':
    case 'rent':
    case 'new-buildings':
      return (<VerticalPromo/>);
    case 'commercial':
      return (<CommercialPromo/>);
    default:
      return;
    }
  }

  public renderServices() {
    switch (this.props.section) {
      case 'index':
        return;
      case 'daily-rent':
      case 'commercial':
      case 'sale':
      case 'rent':
        return (<SaleServices/>);
      case 'new-buildings':
        return (<NewBuildingsServices/>);
      default:
        return;
    }
  }

  public renderPopular() {
    if (this.props.section === 'new-buildings') {
      return (
        <JKPopularList
          services={ this.renderServices() }
        />
      );
    } else {
      return (
        <PopularList
          showLinkToAll={ (this.props.section !== 'index') }
          services={ this.renderServices() }
        />
      );
    }
  }

  public render() {
    if (this.props.isFetching) {
      return null;
    }

    const { section } = this.props;

    return (
      <div>
        <FiltersContainer>
          <NewBuildingCaption section={section} />
          <Filters section={section} />
        </FiltersContainer>

        { this.renderPromo() }

        <TwoColumnContainer
          wideRow={(section === 'commercial')}
          popularPresented={this.popularPresented()}
        >
          { this.renderPopular() }
          <Specialists
            section={section}
            popularPresented={this.popularPresented()}
          />
        </TwoColumnContainer>

        {section === 'index' &&
          <MagazineContainer />
        }

        {section === 'index' &&
          <VacanciesContainer />
        }

        {section === 'index' &&
          <Services />
        }

        <SeoContainer>
          <SeoBlockContainer />
          <NewSeoUrlsWrapper />
        </SeoContainer>
      </div>
    );
  }

  private popularPresented() {
    return (!!this.props.top3 && this.props.top3.length > 0) ||
            (!!this.props.popularJks && this.props.popularJks.length > 0);
  }
}

const mapStateToProps = (state: IHomeState, props: IHomeProps) => ({
    isFetching: state.mainpage.isFetching,
    top3: state.mainpage.top3,
    popularJks: state.mainpage.popularJks,
    section: props.section,
  })

export const Home = connect<IProps, {}, IHomeProps>(mapStateToProps)(HomeComponent);
